import React from 'react'
import { Container } from 'react-bootstrap'

function AboutScreen() {
  return (
    <Container className="py-4">
      <h2 className="ws-section-title">About WigsNStuff</h2>
      <p className="ws-muted">
        WigsNStuff is dedicated to helping you discover your perfect hair transformation. We curate
        premium-quality wigs with natural textures and modern styles, so you can feel confident every day—
        from subtle, everyday looks to bold statements for special occasions.
      </p>
      <p className="ws-muted">
        Every product is vetted for craftsmanship, comfort, and durability. Our team partners with
        trusted suppliers and performs quality checks to ensure consistency across lengths, styles,
        and materials. We’re here to guide you on cap construction, maintenance, and styling so you
        can get the best from your wig.
      </p>
      <p className="ws-muted">
        Not sure where to start? Use our Filters to browse by style, length, material, and color—or
        reach out via the Contact page for personal assistance. Your confidence is our mission.
      </p>
    </Container>
  )
}

export default AboutScreen


